import React from 'react';
import { NavLink } from 'react-router-dom';
const Common=(props)=>{
    return (
        <div>
            <section className="d-flex align-items-center" id="header">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-10 mx-auto pt-5">
                            <div className="row text-center">
                                <div className="d-flex justify-content-center flex-column col-md-6 pt-lg-0 order-2 order-lg-1">
                                    <h1>{props.name}<br/> <strong className="brand-name">Mian Zohaib Asghar</strong></h1>
                                <h2 className="my-3">We are the team of talented developers, making websites</h2>
                                    <div className="mt-4"> 
                                       <NavLink to={props.visit} className="btn-get-started">{props.btnname}</NavLink>
                                    </div>
                                </div>
                                <div className="col-lg-6 order-1 order-lg-2 header-img">
                                    <img src={props.imgsrc} className="img-fluid animated" alt="Common"/>                                            
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Common;